<div class="body-wrapper bg-paint" [ngClass]="{'bg-paint': showBackground}">
    <router-outlet></router-outlet>
</div>
